module.exports = __webpack_public_path__ + "static/assets/686d544c0d02cc231cc620f02a293c33.svg";